import React from 'react';
import { Link } from 'react-router-dom';

function UnitSearchResult(props) {
  const { unit, units } = props;
  const { path, name } = unit;
  function pathDisplay() {
    const pathArray = path.split(',');
    const pathLength = pathArray.length;

    const pathLinks = pathArray.map((pathUnit, index) => {// eslint-disable-line
      const pathUnitInt = parseInt(pathUnit);
      const unitInfo = units[pathUnitInt];
      if (unitInfo) {
        const unitName = unitInfo.name;
        const unitTitle = (
          <React.Fragment>
            {unitName}

            {index === pathLength - 1 ? '' : ' > '}
          </React.Fragment>
        );
        return unitTitle;
      }
    });
    return pathLinks;
  }
  return (
    <Link
      className="search-result"
      to={`/units/?path=${path}`}>
      <span className="text-bold" data-test="search-result-name">
        {name}
      </span>
      <span className="text-smallest" data-test="search-result-path">
        {pathDisplay()}
      </span>
    </Link>
  );
}

export default UnitSearchResult;
